import { render } from "./userIndex.vue?vue&type=template&id=297f64fd"
import script from "./userIndex.vue?vue&type=script&lang=js"
export * from "./userIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__